import * as yup from "yup";

export const AdminEarningsSetupValidationSchema = yup.object().shape({
	label: yup
		.string()
		.required("Label is required")
		.min(1, "Minimum length 1 characters")
		.max(25, "Maximum length 25 characters"),
	category: yup.number().required("Category is required"),
	t4Code: yup.number().required("T4 Code is required"),
	rl1Code: yup.string().required("RL-1 Code is required"),
	type: yup.number().required("Type is required"),
	// showIn: yup.number().required("Show in is required"),
	taxEngine: yup.number().required("Tax Enigne Regular is required"),
});
